import React from "react";

// Banda destructiva. Va al pie de la pantalla, debajo de la barra de acción,
// para que nada irreversible comparta fila con una acción segura.
//
// La acción concreta la pasa el padre como children, porque el borrado
// necesita el wiring del modal (openModal("DeleteButtonAccount")) que vive
// en el botón, no acá.
const DangerZone = ({ children, confirmHint }) => (
  <div className="cco-danger-zone">
    <h3>Danger zone</h3>
    <p>Deleting an account stops all cost collection for it. This cannot be undone.</p>
    <ul>
      <li>The account and its stored credentials are removed permanently.</li>
      <li>Scheduled ingestion jobs for this account are cancelled.</li>
      <li>Cost data already collected stays in your reports, but can no longer be refreshed.</li>
    </ul>
    <div className="d-flex align-items-center" style={{ gap: 12, flexWrap: "wrap" }}>
      {children}
      <span className="cco-hint" style={{ marginTop: 0 }}>
        {confirmHint}
      </span>
    </div>
  </div>
);

export default DangerZone;
